import { z } from 'zod';

// Wire shape is snake_case; the ApiClient camelCases it before this runs. Only `id` and `token`
// open the checkout, so the rest stay optional — a cosmetic BE change must not strand anyone.
export const paymentSessionSchema = z.object({
  id: z.string(),
  token: z.string(),
  status: z.string().nullish(),
  sessionType: z.string().nullish(),
  expiresAt: z.string().nullish(),
});
